import {ERROR_COLOR} from "@view/constants/colors";

export const sx = {
    button: {
        width: '41px',
        height: '41px',
        '& .path': {
            fill: ERROR_COLOR
        },
        '&.exportMode': {
            width: '30px',
            height: '30px',
        }
    },
}